import './overview-card.scss';

import classNames from 'classnames';

interface IProps {
  children: React.ReactNode;
  className?: string;
}

// TODO: Компонент используется на других страницах. Нужно переместить в shared.
const OverviewCard: React.FC<IProps> = ({ children, className }) => {
  return (
    <div className={classNames('overview-card', className)}>{children}</div>
  );
};

export default OverviewCard;
